import { useExportDIExcelMutation, useGetDiReportTagQuery } from "../../../redux/services/tagApiSlice";
import EnablementReport from "./EnablementReport"

const DiEnablementReport = () => {
    return (
        <EnablementReport useReportQuery={useGetDiReportTagQuery} useExportMutation={useExportDIExcelMutation} />
    )
}

export default DiEnablementReport;